"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateDisplayFormat = exports.clipboardToMigrate = exports.migrateValue = exports.mergeFieldParams = void 0;
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
/**
 * Fill target field parameters with parameters from the current field
 * if any of the parameters exist
 */
const mergeFieldParams = (fieldTo, fieldFrom) => {
    const fieldToLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldTo.field_type);
    const fieldFromLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldFrom.field_type);
    const fieldFromParams = fieldFromLogic.getCommonFieldParams(fieldFrom);
    const mergedParams = {};
    const mergedParamNames = Object.keys(fieldToLogic.params).filter((paramName) => paramName in fieldFromParams && paramName !== "nested");
    mergedParamNames.forEach((paramName) => {
        // @ts-expect-error: Need to resolve
        mergedParams[paramName] = fieldFromParams[paramName];
    });
    return mergedParams;
};
exports.mergeFieldParams = mergeFieldParams;
/**
 * A fuction that converts field's record value when field migrating.
 *
 * It uses function from fieldLogic's clipboardPasteRules to migrate value
 * when migrationRules is not defined and field type was not changed.
 */
const migrateValue = async (fieldFrom, fieldTo, value, currentValue, userPreferences, extra) => {
    const fieldFromLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldFrom.field_type);
    const migrateFunc = fieldFromLogic.getMigrationFunction(fieldTo.field_type);
    if (migrateFunc) {
        return await Promise.resolve(migrateFunc(fieldFrom, fieldTo, value, currentValue, userPreferences, extra));
    }
    if (fieldTo.field_type !== fieldFrom.field_type) {
        return await Promise.resolve(currentValue);
    }
    const fieldToLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldFrom.field_type);
    const clipboardPasteFunc = fieldToLogic.getClipboardPasteRules(fieldFrom.field_type, fieldFrom);
    if (clipboardPasteFunc) {
        const clipboardToMigrateFunc = (0, exports.clipboardToMigrate)(clipboardPasteFunc);
        return await Promise.resolve(clipboardToMigrateFunc(fieldFrom, fieldTo, value, currentValue, userPreferences, extra));
    }
    return await Promise.resolve(currentValue);
};
exports.migrateValue = migrateValue;
const clipboardToMigrate = (clipboardPasteFunc) => (fieldFrom, fieldTo, value, currentValue, userPreferences, extra) => {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldFrom.field_type);
    const clipboardValue = fieldLogic.prepareValueForClipboard(value, fieldFrom, userPreferences);
    return clipboardPasteFunc(clipboardValue, fieldFrom, fieldTo, userPreferences, currentValue, extra);
};
exports.clipboardToMigrate = clipboardToMigrate;
/**
 * Migrates display format of the field.
 *
 * Uses display format from field if it supported, otherwise changes it to defaultDisplayFormat.
 */
const migrateDisplayFormat = (field, availableDisplayFormats, defaultDisplayFormat) => {
    var _a;
    const isValidDisplayFormat = availableDisplayFormats.includes((_a = field.params.display_format) !== null && _a !== void 0 ? _a : "");
    if (isValidDisplayFormat) {
        return field;
    }
    return {
        ...field,
        params: { ...field.params, display_format: defaultDisplayFormat },
    };
};
exports.migrateDisplayFormat = migrateDisplayFormat;
